'use client'

import Image from 'next/image'
import { motion } from 'motion/react'

import { typographyVariants } from '@ui/web/lib'
import cn from '@config/tailwind/cn'

import { poppins } from '~/font'
import Banner from './banner.webp'

interface SubHeroProps {
  className?: string
}

const fadeUp = (delay: number) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: 'easeOut' as const, delay },
})

export function SubHero({ className }: SubHeroProps) {
  return (
    <section
      className={cn(
        'text-neutral-black mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-4 px-6 pt-6 text-center',
        poppins.className,
        className,
      )}
    >
      <motion.p className={cn(typographyVariants({ variant: 'body-lg' }))} {...fadeUp(0)}>
        20000+ guru dan orang tua telah menggunakannya di sekolah dan di rumah.
      </motion.p>

      <motion.div {...fadeUp(0.12)}>
        <Image src={Banner} alt='' width={360} height={360} draggable={false} className='select-none' />
      </motion.div>
    </section>
  )
}
